export const msalConfig = {
    auth: {
        clientId: "e3b2f26f-b167-4693-8391-1d69bacc5f54",
        authority: "https://login.microsoftonline.com/common", // Veya belirli bir tenant ID
        redirectUri: "http://localhost:3000/login",
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

// Login sırasında istenecek izinler
export const loginRequest = {
    scopes: ["User.Read"],

};